import { render } from "./ConversationSelector.vue?vue&type=template&id=74203c8a&scoped=true"
import script from "./ConversationSelector.vue?vue&type=script&lang=js"
export * from "./ConversationSelector.vue?vue&type=script&lang=js"

import "./ConversationSelector.vue?vue&type=style&index=0&id=74203c8a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74203c8a"]])

export default __exports__